import React from 'react';

import BlogPostMetaTitle from '../../blog/BlogPostMetaTitle/BlogPostMetaTitle';
import ReadMoreButton from '../../buttons/ReadMoreButton/ReadMoreButton';

import './BlogPostExcerptCard.css';

const BlogPostExcerptCard = ({ blogPost }) => {
  return (
    <div className='blog-post-excerpt-card-container'>
      <BlogPostMetaTitle
        blogPost={blogPost}
        titleLinkTo={`/blog/${blogPost.slug}`}
        commentsCountIconLinkTo={`/blog/${blogPost.slug}#blog-post-detail-comments-title`}
      />
      <p className='blog-post-excert-card-excerpt'>{blogPost.excerpt}</p>
      <ReadMoreButton to={`/blog/${blogPost.slug}`}></ReadMoreButton>
    </div>
  );
};

export default BlogPostExcerptCard;
